// 前端用nginx代理https 443端口+配置推广词

// 线上前端请求后端IP+端口

//export const WHITE_IP = "localhost:3333"
export const WHITE_IP = "wdfgdzx.top:3333"
